import { render, staticRenderFns } from "./PatientCardTimeline.vue?vue&type=template&id=2e1c1766&scoped=true"
import script from "./PatientCardTimeline.vue?vue&type=script&lang=js"
export * from "./PatientCardTimeline.vue?vue&type=script&lang=js"
import style0 from "./PatientCardTimeline.vue?vue&type=style&index=0&id=2e1c1766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1c1766",
  null
  
)

export default component.exports